import { useEffect, useMemo, useState } from 'react'
import { getApi } from '../../api/api'
import { ClusterInterface } from '../../common/types/interfaces'

export const useMainNew = () => {
  const [clusters, setClusters] = useState<ClusterInterface[]>([])
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        setLoading(true)
        const data = await getApi().getPublicClusterList({ target: 'logid' })
        if (!cancelled) setClusters(data || [])
      } catch {
        if (!cancelled) setError('Не удалось загрузить проекты')
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const projects = useMemo(() => clusters.filter((c) => !c.isDemo), [clusters])
  const demos = useMemo(() => clusters.filter((c) => c.isDemo), [clusters])

  return { projects, demos, isLoading, error }
}
